"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDisplayText = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  font-size: 28px;\n  font-weight: ", ";\n  line-height: 34px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  font-size: 40px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: ", ";\n  ", "\n  color: ", ";\n  font-weight: ", ";\n  font-family: ", ";\n  line-height: 48px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getDefaultColor = function getDefaultColor(props) {
  var color = (0, _versions.getColor)(props, 'text');
  return {
    text: color["default"]
  };
};

var BaseDisplayText = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.lean ? 0 : '1em 0';
}, ''
/* color: ${props => baseColors[props.color] || colors.text.default}; */
, function (props) {
  return _tokens.baseColors[props.color] || getDefaultColor(props).text;
}, _tokens.fonts.weight.normal, _tokens.fonts.family.text);

var StyledDisplayText = [];
exports.StyledDisplayText = StyledDisplayText;
StyledDisplayText[1] = BaseDisplayText.extend(_templateObject2());
StyledDisplayText[2] = BaseDisplayText.extend(_templateObject3(), _tokens.fonts.weight.semiBold);

var DisplayText = function DisplayText(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var Component = StyledDisplayText[props.size] || StyledDisplayText[2];
  return _react["default"].createElement(Component, props, children); // return (
  //   <Consumer>
  //     {({ version }) => (
  //       <Component {...props} version={version}>
  //         {children}
  //       </Component>
  //     )}
  //   </Consumer>
  // )
};

DisplayText.propTypes = {
  lean: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf([1, 2]),
  color: _propTypes["default"].string,
  children: _propTypes["default"].string
};
DisplayText.defaultProps = {
  lean: false,
  size: 1,
  children: null
};
DisplayText.displayName = 'DisplayText';

var _default = (0, _context.withVersion)(DisplayText);

exports["default"] = _default;